import { render, staticRenderFns } from "./registration-link-error.vue?vue&type=template&id=3123747f&scoped=true"
import script from "./registration-link-error.vue?vue&type=script&lang=js"
export * from "./registration-link-error.vue?vue&type=script&lang=js"
import style0 from "./registration-link-error.vue?vue&type=style&index=0&id=3123747f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123747f",
  null
  
)

export default component.exports